document.addEventListener('DOMContentLoaded', function () {
  const canvasElements = document.querySelectorAll('.pattern-canvas');

  canvasElements.forEach((canvas) => {
    const ctx = canvas.getContext('2d');
    const img = new Image();

    function resizeCanvas() {
      const container = canvas.closest('.pattern-container');

      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;

      drawPattern();
    }

    function drawPattern() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const tileWidth = 2070;
      const tileHeight = 1846;
      const verticalOffset = tileHeight * 0.5;
      const horizontalOffset = tileWidth * 0.5;

      const horizontalOverlap = 780;
      const verticalOverlap = 556;

      const stepX = tileWidth - horizontalOverlap;
      const stepY = tileHeight - verticalOverlap;

      for (let y = -tileHeight; y < canvas.height + tileHeight; y += stepY) {
        const rowOffset = (y / stepY) % 2 === 0 ? 0 : horizontalOffset;

        for (let x = -tileWidth; x < canvas.width + tileWidth; x += stepX) {
          ctx.drawImage(img, x + rowOffset, y, tileWidth, tileHeight);
        }
      }
    }

    img.onload = function () {
      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
    };

    // Speed fix Oct 2026: the tile image is ~450 KB, so only download it
    // when the pattern is about to scroll into view.
    function loadImage() {
      img.src = canvas.dataset.image || '';
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            loadImage();
          }
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(canvas.closest('.pattern-container') || canvas);
    } else {
      loadImage();
    }
  });
});
